import { render, staticRenderFns } from "./StatisticCardWithAreaChart.vue?vue&type=template&id=9dee65f4&"
import script from "./StatisticCardWithAreaChart.vue?vue&type=script&lang=js&"
export * from "./StatisticCardWithAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports